import { render, staticRenderFns } from "./BlipActiveMessagesByChannel.vue?vue&type=template&id=0eccd6b7&scoped=true&"
import script from "./BlipActiveMessagesByChannel.vue?vue&type=script&lang=js&"
export * from "./BlipActiveMessagesByChannel.vue?vue&type=script&lang=js&"
import style0 from "./BlipActiveMessagesByChannel.vue?vue&type=style&index=0&id=0eccd6b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eccd6b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VDataTable,VRow})
